var _path, _path2, _path3, _path4, _line, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigurantaAutomataInchisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7695 80.0781L38.7006 46.0198",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5693 32.9102L38.5693 0.075677",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5698 80.0742L38.5698 47.0885",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8555 53.1992C21.8555 53.6134 22.1913 53.9492 22.6055 53.9492L29.3555 53.9492C29.7697 53.9492 30.1055 53.6134 30.1055 53.1992C30.1055 52.785 29.7697 52.4492 29.3555 52.4492H23.3555V46.4492C23.3555 46.035 23.0197 45.6992 22.6055 45.6992C22.1913 45.6992 21.8555 46.035 21.8555 46.4492L21.8555 53.1992ZM34.0751 40.6689L22.0751 52.6689L23.1358 53.7295L35.1358 41.7295L34.0751 40.6689Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.4259,
    y1: 39.105,
    x2: 14.5209,
    y2: 43.9711,
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5632 39.0103L22.6235 43.2779",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.209 35.5938L26.6048 39.7038",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1333 36.1953L26.7213 31.3253",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 38.9922L23.0212 42.9176",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5872 33L54.9513 33L71.9024 33",
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51 22.9375L38.5 47.5",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigurantaAutomataInchisa);
export default __webpack_public_path__ + "static/media/siguranta_automata_inchisa.61e00d4c847281a7210f46885d26cdaf.svg";
export { ForwardRef as ReactComponent };